/**************************************************
 * Nombre:       Producto_Especificaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {useEffect, useState} from "react";


const Producto_Especificaciones = ({item = {}}) => {
    const [escogido, setEscogido] = useState({})


    useEffect(() => {

        if (item.informaciones && item.informaciones.length > 0 && escogido.nombre === undefined) {
            setEscogido(item.informaciones[0])
        }

    }, [item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}
                  spacing={4}
            >
                {item.informaciones && item.informaciones.map((it, index) => (
                    <Typography
                        onClick={() => setEscogido(it)}
                        sx={{
                            fontSize: 16,
                            fontWeight: 400,
                            px: 3,
                            backgroundColor: escogido.nombre === it.nombre ? theme.palette.secondary.main : '',
                            borderRadius: 6,
                            py: 1,
                            color: escogido.nombre === it.nombre ? '#fff' : '#000',
                            cursor: 'pointer',
                        }}>{it.nombre}</Typography>
                ))}
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{backgroundColor: '#fff', p: 4}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography>
                            {escogido.descripcion}
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Producto_Especificaciones

const items = ['Descripcion', 'Modo de Uso', 'Recomendaciones']